var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 2.5c1.566.783 3.13.95 5.315.303.472-.14.685.1.685.471v7.419c0 .2-.027.322-.281.441-1.899.887-3.813.82-5.719-.134-1.333-.667-2.667-.722-4-.5V14a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1c.496 0 .908.526.987 1C5.32 1.774 6.662 1.831 8 2.5z"}));
}

Flag.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Flag;

Flag.default = Flag;
